<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <form @submit.prevent="handleFormSubmit">
      <div class="form-row">
        <div class="form-group col-md-6 mb-2">
          <ValidationProvider name="PTA" rules="required" v-slot="{ errors }">
            <label class="form-label">PTA <span class="text-danger">*</span></label>
            <multi-select
                disabled
                :options="[payload.idPta]"
                placeholder="Sélectionnez une activité PTA"
                label="description"
                track-by="id"
                :searchable="false"
                v-model="payload.idPta"
                :custom-label="o => o.description"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <strong> {{ option.description }}</strong>
              </template>
              <span slot="noOptions"><strong>Liste Vide</strong></span>
              <span slot="noResult"><strong>Aucun Résultat</strong></span>
            </multi-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>

        <div class="form-group col-md-6 mb-2">
          <ValidationProvider name="Achèvement" rules="required" v-slot="{ errors }">
            <label for="achevement" class="form-label">Achèvement <span class="text-danger">*</span></label>
            <textarea id="achevement" class="form-control" v-model="payload.achevement" placeholder="Description de l’achèvement" rows="3"></textarea>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>


      </div>

      <div class="form-row">

        <div class="form-group col-md-6 mb-2">
          <ValidationProvider name="Causes du retard" rules="required" v-slot="{ errors }">
            <label for="causesRetard" class="form-label">Causes du retard <span class="text-danger">*</span></label>
            <textarea id="causesRetard" class="form-control" v-model="payload.causesRetard" placeholder="Précisez les causes" rows="3"></textarea>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>

        <div class="form-group col-md-6 mb-2">
          <ValidationProvider name="Structure responsable" rules="required" v-slot="{ errors }">
            <label for="structureResp" class="form-label">Structure responsable <span class="text-danger">*</span></label>
            <textarea id="structureResp" class="form-control" v-model="payload.structureResp" placeholder="Ex: Direction Technique" rows="2"></textarea>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>

      </div>

      <div class="form-row">

        <div class="form-group col-md-6 mb-2">
          <ValidationProvider name="Difficultés" rules="required" v-slot="{ errors }">
            <label for="difficultes" class="form-label">Difficultés rencontrées <span class="text-danger">*</span></label>
            <textarea id="difficultes" class="form-control" v-model="payload.difficultes" placeholder="Les difficultés rencontrées" rows="2"></textarea>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>

        <div class="form-group col-md-6 mb-2">
          <ValidationProvider name="Solutions" rules="required" v-slot="{ errors }">
            <label for="solutions" class="form-label">Solutions proposées <span class="text-danger">*</span></label>
            <textarea id="solutions" class="form-control" v-model="payload.solutions" placeholder="Mesures correctives" rows="2"></textarea>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>

      </div>

      <div class="form-row">

        <div class="form-group col-md-6 mb-2">
          <ValidationProvider name="Éligible RPT" rules="required" v-slot="{ errors }">
            <label for="eligibleRpt" class="form-label">Éligible RPT <span class="text-danger">*</span></label>
            <select id="eligibleRpt" class="form-select " v-model="payload.eligibleRpt">
              <option disabled value="">-- Sélectionner --</option>
              <option value="Oui">Oui</option>
              <option value="Non">Non</option>
            </select>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>

        <div class="form-group col-md-6 mb-2">

        </div>

      </div>



      <div class="form-group text-end mt-3">
        <button class="btn btn-gray me-2" type="button" @click="$emit('cancel')">Annuler</button>
        <button class="btn btn-success" type="submit" :disabled="invalid">
          <span class="fe" :class="isEditing ? 'fe-edit' : 'fe-check'"></span>
          {{ isEditing ? 'Modifier' : 'Enregistrer' }}
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
  import GenericSelect from "../GenericSelect.vue";

  export default {
    components: {GenericSelect},
    props: {
      value: {
        type: Object,
        required: false,
        default: () => ({})
      }
    },
    data() {
      return {
        payload: {
          id : null,
          idPta:{},
          achevement: '',
          causesRetard: '',
          structureResp: '',
          difficultes: '',
          solutions: '',
          eligibleRpt: ''
        },


      };
    },
    watch: {
      value: {
        immediate: true,
        deep: true,
        async handler(newVal) {
          this.$loading(true);

          try {
            this.payload = { ...this.payload, ...newVal };
          } catch (e) {
            console.error("Erreur dans le watch de value :", e);
          } finally {
            this.$loading(false);
          }
        }
      }
    },
    created() {
      // this.loadData();
    },
    computed: {
      isEditing() {
        return this.payload.id !== null && this.payload.id !== undefined && this.payload.id !== '';
      }
    },
    methods:{
      async handleFormSubmit() {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;
        console.log('Formulaire soumis avec :', this.payload);
        if(!this.isEditing){

          this.$loading(true);
          this.$http.post('/retards', this.payload)
              .then(({ data }) => {
                if (data) {
                  swal('Information!', 'Enregistrement éffectué avec succès.', 'success');
                  // this.$refs.tableRef.loadData();
                  if (this.$refs.observer) {
                    this.$refs.observer.reset();
                  }
                } else {
                  swal('Information!', 'Erreur lors de l\'enregistrement', 'warning');
                }
              })
              .catch((error) => {
                swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'warning');
              })
              .finally(() => this.$loading(false));


        }else {

          this.$loading(true);
          this.$http.put('/retards/' + this.payload.id, this.payload)
              .then(({ data }) => {
                if (data) {
                  swal('Information!', 'Modification éffectuée avec succès.', 'success');
                  // this.$refs.tableRef.loadData();
                  if (this.$refs.observer) {
                    this.$refs.observer.reset();
                  }
                } else {
                  swal('Information!', 'Erreur lors de la modification.', 'warning');
                }
              })
              .catch((error) => {
                swal('Information!', 'Une erreur est survenue lors de la modification. ' + error, 'warning');
              })
              .finally(() => this.$loading(false));

        }
        this.$emit('refresh');
        this.$emit('cancel');
      },

    }
  };

</script>
